/**
 * Event Emitter enums
 * @module
 */

exports.TYPES = {
  ACTION: 'action',
  ANALYTICS: 'analytics',
  EDITOR: 'editor',
  LIFECYCLE: 'lifecycle',
};
